<ng-template #mobileFacetPopup>
  <div
    class="
      ui
      no
      shadow
      full-wrapper
      overlay
      fullscreen
      modal
      front
      scrolling
      transition
      active
      longer
      test
      modal
      transition
      visible
      active
      front
    "
    [ngClass]="{
      visible: toggleModalVisibility,
      hidden: !toggleModalVisibility
    }"
  >
    <div class="ui center fw-100 aligned header">
      Filter Results
      <a class="" (click)="isShowFilter()">
        <i class="close icon"></i>
      </a>
    </div>
    <div class="scrolling image content">
      <div class="description">
        <signgaze-facet-container></signgaze-facet-container>
      </div>
    </div>
    <div class="actions">
      <div class="ui fluid primary approve button" (click)="isShowFilter()">
        Apply Filters
      </div>
    </div>
  </div>
</ng-template>
<div class="ui grid">
  <div class="stretched row">
    <div class="sixteen-wide-mobile mobile-only column mpd-0">
      <ng-container *ngTemplateOutlet="mobileFacetPopup"></ng-container>
    </div>
    <div class="sixteen-wide-tablet tablet-only column">
      <ng-container *ngTemplateOutlet="mobileFacetPopup"></ng-container>
    </div>
    <div class="three-wide-computer computer-only column mpd-0">
      <div class="ui segment">
        <signgaze-facet-container></signgaze-facet-container>
      </div>
    </div>
    <div
      class="
        sixteen-wide-mobile sixteen-wide-tablet
        thirteen-wide-computer
        column
      "
    >
      <ng-container [ngSwitch]="pageState">
        <ng-container *ngSwitchCase="pageStateEnum.LOADING">
          <div class="ui one column padded grid">
            <div class="column">
              <monorepo-loading-spinner
                [loaderType]="LoadingTypeEnum.SPINNER"
              ></monorepo-loading-spinner>
            </div>
          </div>
        </ng-container>
        <ng-container *ngSwitchCase="pageStateEnum.LOADED">
          <div class="ui secondary no border listing-hits-container segment">
            <ais-hits>
              <ng-container> </ng-container>
              <ng-template let-hits="hits" let-results="results">
                <div class="ui one column padded grid" *ngIf="hits === null">
                  <div class="column">
                    <monorepo-loading-spinner
                      [loaderType]="LoadingTypeEnum.SPINNER"
                    ></monorepo-loading-spinner>
                  </div>
                </div>
                <div
                  class="ui one column padded grid"
                  *ngIf="hits.length === 0"
                >
                  <div class="column">
                    <monorepo-empty-state [statetype]="StateTypeEnum.TABLE">
                    </monorepo-empty-state>
                  </div>
                </div>
                <div class="hits-container" *ngIf="hits.length !== 0">
                  <div class="ui grid">
                    <div class="row">
                      <ng-container *ngFor="let hit of hits">
                        <div
                          class="
                            eight-wide-mobile
                            four-wide-tablet four-wide-computer
                            column
                          "
                        >
                          <signgaze-listing-item
                            [screenListing]="hit"
                          ></signgaze-listing-item>
                        </div>
                      </ng-container>
                    </div>
                  </div>
                </div>
              </ng-template>
            </ais-hits>
            <div class="ui basic very padded horizontally fitted segment">
              <ais-pagination></ais-pagination>
            </div>
          </div>
        </ng-container>
      </ng-container>
    </div>
  </div>
</div>
